<template>
    <client-page>
        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="client-title--xxxl">함께하는 사람들</h2>
                    </div>
                    <v-tabs grow hide-slider>
                        <v-tab @click="scrollToSection('association')">위드캔 후원회</v-tab>
                        <v-tab @click="scrollToSection('ambassador')">위드캔 엠버서더</v-tab>
                        <v-tab @click="scrollToSection('corporate')">후원사</v-tab>
                    </v-tabs>
                </v-container>
            </section>

            <section class="client-section pt-0" id="association">
                <v-container>
                    <div class="section-title-wrap">
                        <p class="client-title--sm font-weight-medium primary--text line-height-15">With Aid Association</p>
                        <h2 class="section-title">함께하는 후원회</h2>
                        <p class="section-subtitle grey-1--text">
                            위드캔 후원회는 초저출생 고령화시대 대두되는 다양한 가정 문제 해결과 아동의 인권을 존중하며 아동이 건강하고 안전하게 성장하고, <br class="d-none d-xl-block" />
                            자신의 꿈을 펼칠 수 있는 사회 환경을 조성한다는 목적으로 연간 일정 금액 이상을 정기 후원 및 일시 납부하는 개인 후원자의 자발적 모임입니다.
                        </p>
                    </div>

                    <v-card color="primary" flat class="people-card">
                        <v-img src="/images/about/people/association.webp" alt="" />
                        <div class="people-card__text">
                            <v-card-title class="justify-center white--text line-height-14">
                                <div class="client-title font-size-md-36 text-center">
                                    위드캔 후원회 관련상담 <br class="d-md-none" />
                                    02-2057-2296
                                </div>
                            </v-card-title>
                        </div>
                    </v-card>
                </v-container>
            </section>

            <section>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-img src="/images/about/people/association-1.jpg" alt="" class="border-radius-16" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-img src="/images/about/people/association-2.jpg" alt="" class="border-radius-16" />
                        </v-col>
                        <!-- <v-col cols="4">
                            <v-img src="/images/about/people/association-3.jpg" alt="" class="border-radius-16" />
                        </v-col>
                        <v-col cols="4">
                            <v-img src="/images/about/people/association-4.jpg" alt="" class="border-radius-16" />
                        </v-col>
                        <v-col cols="4">
                            <v-img src="/images/about/people/association-5.jpg" alt="" class="border-radius-16" />
                        </v-col> -->
                    </v-row>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <h2 class="client-title--lg text-center">
                                2025년 사회복지법인 위드캔복지재단 <br />
                                <span class="primary--text">‘함께하는(With-CAN)후원회’ 명단</span>
                            </h2>
                        </v-col>
                        <v-col cols="12">
                            <people-supporters />
                        </v-col>
                    </v-row>
                </v-container>
            </section>

            <section class="client-section" id="ambassador">
                <v-container>
                    <div class="section-title-wrap">
                        <p class="client-title--sm font-weight-medium primary--text line-height-15">With Ambassador</p>
                        <h2 class="section-title">함께하는 앰버서더</h2>
                    </div>

                    <v-row justify="center">
                        <v-col v-for="(ambassador, index) in ambassadors" :key="index" cols="6" lg="4">
                            <v-card tile flat max-width="384" class="mx-auto h-100">
                                <v-img :src="ambassador.image" alt="" class="border-radius-16" />
                                <v-card-subtitle class="pb-0 pt-lg-24">
                                    <div class="page-text page-text--lg font-weight-bold primary--text text-center">
                                        {{ ambassador.job }}
                                    </div>
                                </v-card-subtitle>
                                <v-card-title class="pt-8">
                                    <div class="tit tit--sm text-center">
                                        {{ ambassador.name }}
                                    </div>
                                </v-card-title>
                                <v-card-text class="pb-36">
                                    <p v-html="ambassador.text" class="page-text page-text--lg text-center" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>

            <section class="client-section" id="corporate">
                <v-container>
                    <div class="section-title-wrap">
                        <p class="client-title--sm font-weight-medium primary--text line-height-15">With Corporate partnership</p>
                        <h2 class="section-title">함께하는 기업</h2>
                        <v-btn to="/guide/company" large outlined color="primary" rounded="pill" class="mt-24 mt-lg-32">
                            <span class="page-text page-text--lg primary--text">기업후원 더 알아보기</span>
                            <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>

                    <v-row justify="center">
                        <v-col v-for="(corporate, index) in corporates" :key="index" cols="6" lg="4">
                            <v-card tile flat max-width="384" class="h-100 mx-auto">
                                <v-img :src="corporate.image" class="border-radius-16"></v-img>
                                <v-card-title class="justify-center text-center pb-0 tit tit--sm">
                                    {{ corporate.title }}
                                </v-card-title>
                            </v-card>
                        </v-col>
                    </v-row>

                    <sponsor-slide class="pt-60 pt-lg-80" />
                    <!-- <main-partners class="pt-60 pt-lg-80" /> -->
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SponsorSlide from "@/components/client/dumb/sponsor-slide.vue";
import MainPartners from "@/components/client/main/main-partners.vue";
import PeopleSupporters from "@/components/client/about/people-supporters.vue";

export default {
    components: {
        ClientPage,
        SponsorSlide,
        MainPartners,
        PeopleSupporters,
    },
    data() {
        return {
            ambassadors: [
                {
                    job: "배우",
                    name: "권해성",
                    text: "탄탄한 연기력과 따뜻한 이미지를 바탕으로, <br class='d-none d-xl-block'>국내 복지사업을 적극 알리며 <br class='d-none d-xl-block'>소외된 이웃들에게 희망을 전합니다.",
                    image: "/images/about/people/ambassador-1.jpg",
                },
                {
                    job: "배우",
                    name: "이세은",
                    text: "섬세한 감정 표현과 따뜻한 미소로 사랑받는 배우로 <br class='d-none d-xl-block'>국내 복지사업의 의미를 진정성 있게 전하며 <br class='d-none d-xl-block'>도움이 필요한 이웃들에게 희망과 위로를 건넵니다. ",
                    image: "/images/about/people/ambassador-6.jpg",
                },
                {
                    job: "방송인",
                    name: "정가은",
                    text: "밝은 에너지로 대중과 소통하며, <br class='d-none d-xl-block'>가족·아동·여성을 위한 국내 복지사업에 <br class='d-none d-xl-block'>앞장서서 나눔 문화를 확산시킵니다.",
                    image: "/images/about/people/ambassador-2.jpg",
                },
                {
                    job: "모델",
                    name: "최정은",
                    text: "세련된 이미지와 진취적인 자세로, <br class='d-none d-xl-block'>취약계층 지원 활동에 참여하며 도움의 손길이 <br class='d-none d-xl-block'>필요한 이들에게 실질적인 지원을 전합니다.",
                    image: "/images/about/people/ambassador-3.jpg",
                },
                {
                    job: "모델",
                    name: "정여아",
                    text: "우아한 아름다움과 프로 의식을 더해, <br class='d-none d-xl-block'>지역사회 어르신·아동 등 소외계층을 위한 <br class='d-none d-xl-block'>현장 중심 복지사업에 힘을 보태고 있습니다.",
                    image: "/images/about/people/ambassador-4.jpg",
                },
                {
                    job: "쇼호스트",
                    name: "김봉희",
                    text: "유쾌하고 친근한 진행으로 <br class='d-none d-xl-block'>많은 이들의 관심을 모으며, 국내 소외계층 <br class='d-none d-xl-block'>지원 캠페인에 적극 참여해 희망을 퍼뜨립니다.",
                    image: "/images/about/people/ambassador-5.jpg",
                },
            ],
            corporates: [
                {
                    image: "/images/about/people/corporate-1.jpg",
                    title: "아방데코 위드스토어 협약",
                },
                {
                    image: "/images/about/people/corporate-2.jpg",
                    title: "ABL생명 사회공헌 기부",
                },
                {
                    image: "/images/about/people/corporate-3.jpg",
                    title: "법무법인 덕수 법률지원",
                },
            ],
        };
    },
    methods: {
        scrollToSection(sectionId) {
            const section = document.getElementById(sectionId);
            if (section) {
                window.scrollTo({
                    top: section.offsetTop,
                    behavior: "smooth",
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.v-tabs {
    ::v-deep(.v-slide-group__prev) {
        display: none;
    }
    .v-tab {
        background-color: #f5f5f5;
        &:first-of-type {
            border-top-left-radius: 999px;
            border-bottom-left-radius: 999px;
        }
        &:last-of-type {
            border-top-right-radius: 999px;
            border-bottom-right-radius: 999px;
        }
        &--active {
            background-color: var(--v-primary-base);
            color: #fff;
        }
    }
}
.people-card {
    border-radius: 16px;
    &__text {
        background: url(/images/business/intro-logo.svg) no-repeat;
        background-position-x: calc(100% - 20px);
        background-position-y: center;
        background-size: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
@media (min-width: 768px) {
    .v-tabs {
        ::v-deep(.v-tabs-bar),
        .v-tab {
            height: 60px;
        }
    }
    .people-card {
        &__text {
            background-position-x: calc(100% - 72px);
            background-size: 273px;
            min-height: 178px;
        }
    }
    .v-data-table {
        th,
        td {
            font-size: 18px !important;
        }
    }
}
</style>